export enum PRINT_TYPE {
    APPLICATION_FORM = "applicationForm",
    DOMESTIC_PARTNER_ATTESTATION = "domesticPartnerAttestation"
}